import { selectCountries } from "../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../components/enums";
import {
  FormSchema,
  ComplexFormSchemaComponents,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { Url } from "../../../../router/enums";
import { defaultCountry, provinces } from "../../../../shared";
import {
  selectCountry,
  selectIsDefaultCountrySelected,
  selectIsNotDefaultCountrySelected,
} from "../../../../store/HOC/genericUI.selectors";
import { postalCodeMask } from "../../../../utilities/masks";
import {
  selectApplicantAdditionalData,
  selectApplicantAdditionalPersonsData,
  selectApplicantAvailableCities,
  selectShouldDisplayOtherPersons,
  selectUIData,
} from "../applicant.selectors";
import {
  setAvailableCities,
  setPersonsAreInvolved,
  setUIField,
  setUIObjectField,
} from "../applicant.slice";

import { ComponentId } from "./enums";

export const multiplePersonForm = (
  id: string
): FormSchema<SimpleFormSchemaComponents> => ({
  id,
  formId: FormId.APPLICANT_ADDITIONAL,
  selector: selectApplicantAdditionalPersonsData,
  content: [
    {
      title: "Dane osoby",
      sections: [
        {
          id: ["persons-section-data-1", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: `persons[${id}][name]`,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][surname]`,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: ["persons-section-data-2", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)(
                `additionalpersons${id}phone`
              ),
              id: `persons[${id}][phone]`,
              onChange: setUIObjectField,
              label: "Telefon",
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][email]`,
              label: "Email",
              required: true,
            },
          ],
        },
      ],
    },
    {
      title: "Miejsce zamieszkania",
      sections: [
        {
          id: ["persons-section-address-data-1", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: `persons[${id}][street]`,
              label: "Ulica",
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][street2]`,
              label: "Numer budynku / mieszkania",
            },
          ],
        },
        {
          id: ["persons-section-address-data-2", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                `additional[persons[${id}][country]]`
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: `persons[${id}][zipCodePL]`,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                `additional[persons[${id}][country]]`
              ),
              type: FormElement.INPUT,
              id: `persons[${id}][zipCodeGeneric]`,
              label: "Kod pocztowy",
            },
            // LPPLWEBMOB-728
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: `persons[${id}][city]`,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectApplicantAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.INPUT,
              id: `persons[${id}][city]`,
              label: "Miejscowość",
            },
          ],
        },
        {
          id: ["persons-section-address-data-3", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: `persons[${id}][country]`,
              defaultValue: { ...defaultCountry },
              onChange: setUIField,
              items: selectCountries,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: `persons[${id}][province]`,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                `additional[persons[${id}][country]]`
              ),
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
        {
          id: ["persons-section-address-data-4", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: `persons[${id}][role]`,
              required: true,
              label: "Jaki był udział tej osoby w zdarzeniu",
              items: [
                {
                  label: "świadek",
                  value: "Witness",
                },
                {
                  label: "uczestnik",
                  value: "Participant",
                },
                {
                  label: "inny",
                  value: "Other",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

export const form: FormSchema<
  ComplexFormSchemaComponents | SimpleFormSchemaComponents
> = {
  formId: FormId.APPLICANT_ADDITIONAL,
  selector: selectApplicantAdditionalData,
  redirect: Url.AC_INCIDENT,
  content: [
    {
      sections: [
        {
          id: "applicant-additional-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.APPLICANT_ADDITIONAL_ARE_OTHER_PEOPLE_INVOLVED,
              required: true,
              label: "Czy w zdarzeniu brały udział inne osoby?",
              onChange: setPersonsAreInvolved,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "applicant-additional-data-2",
          isVisible: selectShouldDisplayOtherPersons,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MULTIPLE_PERSON,
              id: ComponentId.APPLICANT_ADDITIONAL_PERSONS,
              form: multiplePersonForm,
            },
          ],
        },
      ],
    },
  ],
};
